"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseFilterableListParent = exports.FilterableListTypeEnum = exports.FilterSortOptions = exports.FilterGroupTypeAlias = exports.FilterGroupGuiTypeEnum = void 0;
var FilterGroupGuiTypeEnum;
(function (FilterGroupGuiTypeEnum) {
    FilterGroupGuiTypeEnum[FilterGroupGuiTypeEnum["Checkbox"] = 0] = "Checkbox";
    FilterGroupGuiTypeEnum[FilterGroupGuiTypeEnum["Radio"] = 1] = "Radio";
    FilterGroupGuiTypeEnum[FilterGroupGuiTypeEnum["Dropdown"] = 2] = "Dropdown";
    FilterGroupGuiTypeEnum[FilterGroupGuiTypeEnum["Textbox"] = 3] = "Textbox";
    FilterGroupGuiTypeEnum[FilterGroupGuiTypeEnum["Autosuggest"] = 4] = "Autosuggest";
    FilterGroupGuiTypeEnum[FilterGroupGuiTypeEnum["Hierarchy"] = 5] = "Hierarchy";
    FilterGroupGuiTypeEnum[FilterGroupGuiTypeEnum["DropdownMulti"] = 6] = "DropdownMulti";
})(FilterGroupGuiTypeEnum || (exports.FilterGroupGuiTypeEnum = FilterGroupGuiTypeEnum = {}));
var FilterGroupTypeAlias;
(function (FilterGroupTypeAlias) {
    FilterGroupTypeAlias["Countries"] = "countryCode";
    FilterGroupTypeAlias["Region"] = "region";
    FilterGroupTypeAlias["ZipCode"] = "zipCode";
    FilterGroupTypeAlias["Segment"] = "segment";
    FilterGroupTypeAlias["LearningEventType"] = "learningEventType";
    FilterGroupTypeAlias["DeliveryTypes"] = "deliveryTypes";
    FilterGroupTypeAlias["Type"] = "type";
    FilterGroupTypeAlias["Hierarchy"] = "hierarchy";
    FilterGroupTypeAlias["ProductHierarchy"] = "productHierarchy";
    FilterGroupTypeAlias["Archived"] = "archived";
    FilterGroupTypeAlias["City"] = "city";
    FilterGroupTypeAlias["ProductType"] = "productType";
    FilterGroupTypeAlias["ProductSeries"] = "productSeries";
    FilterGroupTypeAlias["ProductGroup"] = "productGroup";
    FilterGroupTypeAlias["ProductionSite"] = "productionSite";
})(FilterGroupTypeAlias || (exports.FilterGroupTypeAlias = FilterGroupTypeAlias = {}));
var FilterSortOptions;
(function (FilterSortOptions) {
    FilterSortOptions["FromNowToFuture"] = "fromNowToFuture";
    FilterSortOptions["FromFutureToNow"] = "fromFutureToNow";
    FilterSortOptions["PastEvents"] = "pastEvents";
    FilterSortOptions["TitleAsc"] = "title_asc";
    FilterSortOptions["TitleDesc"] = "title_desc";
    FilterSortOptions["Default"] = "default_sort";
    FilterSortOptions["StartDateAsc"] = "startDate_asc";
    FilterSortOptions["StartDataDesc"] = "startDate_desc";
    FilterSortOptions["SoftwareReleaseDateAsc"] = "software_release_date_asc";
    FilterSortOptions["SoftwareReleaseDateDesc"] = "software_release_date_desc";
    FilterSortOptions["SoftwareReleaseDateRelevance"] = "";
})(FilterSortOptions || (exports.FilterSortOptions = FilterSortOptions = {}));
var FilterableListTypeEnum;
(function (FilterableListTypeEnum) {
    FilterableListTypeEnum[FilterableListTypeEnum["ProductCategories"] = 0] = "ProductCategories";
    FilterableListTypeEnum[FilterableListTypeEnum["Products"] = 1] = "Products";
    FilterableListTypeEnum[FilterableListTypeEnum["Events"] = 2] = "Events";
    FilterableListTypeEnum[FilterableListTypeEnum["News"] = 3] = "News";
    FilterableListTypeEnum[FilterableListTypeEnum["Downloads"] = 4] = "Downloads";
    FilterableListTypeEnum[FilterableListTypeEnum["CaseStudies"] = 5] = "CaseStudies";
    FilterableListTypeEnum[FilterableListTypeEnum["SearchResults"] = 6] = "SearchResults";
})(FilterableListTypeEnum || (exports.FilterableListTypeEnum = FilterableListTypeEnum = {}));
var BaseFilterableListParent;
(function (BaseFilterableListParent) {
    BaseFilterableListParent[BaseFilterableListParent["FilterableListContainer"] = 0] = "FilterableListContainer";
    BaseFilterableListParent[BaseFilterableListParent["SearchResultsListContainer"] = 1] = "SearchResultsListContainer";
})(BaseFilterableListParent || (exports.BaseFilterableListParent = BaseFilterableListParent = {}));
